import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';

const Entregeeks = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        Entregeeks
      </Box>
      <GridItem as="p">refonte de l expérience utilisateurs et Design de l’interface du réseaux sociale entregeeks.com</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p">– refonte une identité digitale Complete.</GridItem>
      <GridItem as="p">– Concevoir une UX centrée sur la découverte de profils, événements et passions partagées</GridItem>
      <GridItem as="p">– Développer des fonctionnalités clés : matching d’intérêts, agenda collaboratif, salon de discussion</GridItem>
      <GridItem as="p">– Adapter le design à une navigation fluide sur desktop</GridItem>

      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [LIENS]
      </Box>
      <Box>
        <a href="https://entre-geeks.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
          le site entre-geeks.com
        </a>
      </Box>
    </Box>
  );
};

export default Entregeeks;
